var render = function render(_c,_vm){return _c('div',{staticClass:"ru:image"},[_c('img',{attrs:{"src":_vm.props.src,"alt":"","width":_vm.props.width,"height":_vm.props.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }